import { NavLink } from 'react-router-dom';
import { canBeAccepted, canBeCorrected, getBackgroundStyle, getStatusIcon, getStatusLabel } from '../components/CostRefundLogic';
import Modal from 'components/commons/Modal';
import { useTranslation } from 'react-i18next';
import UserImage from 'components/commons/UserImage';

export default function CostRefundCard({
    refund,
    administrable = false,
    onAccept = () => { }
}) {

    const [t, i18n] = useTranslation(["global", "absenceReport"])

    let startDate = new Date(refund.startDate * 1000)
    let endDate = new Date(refund.endDate * 1000)

    let days = Math.round((endDate.getTime() - startDate.getTime()) / (1000 * 3600 * 24) + 1);

    let isSameYear = startDate.getFullYear() == endDate.getFullYear()



    return (<div className="col" key={refund.guid}>
        <div className={`card text-white h-100 ${getBackgroundStyle(refund)}`}>
            <div className="card-header">
                <div className='row'>
                    <div className='col text-start'>
                        {getStatusIcon(refund)} {getStatusLabel(refund, t).toUpperCase()}
                    </div>
                    <div className='col text-end'>
                        <small className="text-body-secondary text-muted text-start">{new Date(refund.lastEditAt).toLocaleString([], { dateStyle: "short", timeStyle: 'short' })}</small>
                    </div>
                </div>



            </div>

            <div className="card-body bg-black bg-opacity-25">

                <div className='row'>
                    {
                        refund.user &&
                        <div className='col-2'>
                            <UserImage guid={refund.user.guid} size={48} />
                        </div>
                    }

                    <div className='col'>
                        <span className='text-muted small'>{refund.user ? refund.user.displayName : t("absenceReport:label.my_cost_refund")}</span><br />
                        <h5 className="card-title">{refund.title}</h5>
                    </div>

                    <div className='col text-end '>
                        {
                            refund.expenseItems.length > 0 &&
                            <small className='text-muted'>{refund.expenseItems.length} {t("global:unit.items", { count: refund.expenseItems.length })}</small>
                        }
                        {
                            refund.totalExpense ?
                                <h4><span className='text-muted'>€</span> {refund.totalExpense.toFixed(2)}</h4>
                                :
                                <h4>---</h4>
                        }
                    </div>
                </div>


            </div>
            <div className="card-footer">
                <p className="card-text">
                    <i className="fa-solid fa-calendar-days text-muted"></i> {days}  {t("global:unit.days", { count: days })}
                    <small className='text-muted ms-2'>
                        {

                            isSameYear ?
                                <> {t("particles.from")} {startDate.getDate()}/{startDate.getMonth() + 1} {t("particles.to")} {endDate.getDate()}/{endDate.getMonth() + 1} {startDate.getFullYear()}</>
                                :
                                <>{new Date(refund.startDate * 1000).toLocaleDateString()} - {new Date(refund.endDate * 1000).toLocaleDateString()}</>
                        }
                    </small>
                </p>
                <div className='row'>

                    {
                        <div className={`col ${refund.distance == 0 && "invisible"}`}>
                            <><i className={`fa-solid fa-road text-muted `}></i> {refund.distance} <span className='text-muted small'>km</span></>
                        </div>
                    }

                    <div className='col '>
                        {
                            refund.attachments && refund.attachments.length > 0 &&
                            <><i className="fa-solid fa-paperclip"></i> {refund.attachments.length}</>
                        }
                    </div>

                </div>
                <div className='text-end'>
                    <div className={`btn-group text-end mt-2 mb-2 `}>

                        <NavLink to={{ pathname: `/dashboard/costRefunds/${administrable ? "detail" : "my/detail"}` }} state={{ guid: refund.guid }} className={`btn btn-secondary`}><i className="fa-solid fa-folder-open"></i> {t("action.open")} </NavLink>

                        {
                            administrable && canBeAccepted(refund) &&
                            <>
                                <Modal
                                    modalId={"acceptModal" + refund.guid}
                                    buttonClass="btn-success"
                                    buttonLabel={<i className="fa-solid fa-circle-check fa-beat"></i>}
                                    buttonIcon={t("action.accept")}
                                    body={t("absenceReport:helper.confirm_accept")}
                                    onConfirm={() => onAccept(refund.guid)}
                                />
                                <button className='btn btn-success' style={{ maxWidth: 0, padding: 3 }}></button>
                            </>
                        }

                        {
                            !administrable && canBeCorrected(refund) &&
                            <NavLink to={{ pathname: "/dashboard/costRefunds/my/edit" }} state={{ costRefund: refund }} className="btn btn-warning"><i className="fa-solid fa-triangle-exclamation fa-beat"></i> {t("action.adjust")}</NavLink>
                        }

                    </div>
                </div>
            </div>
        </div>
    </div>
    )


}